<template>
  <div>
    <v-navigation-drawer
      v-if="showNavigationDrawer"
      expand-on-hover
      :mobile-breakpoint="customMobileBreakpoint"
      color="primary"
      app
      clipped
    >
      <v-divider></v-divider>
      <!-- Elementos de menú con enrutamiento -->
      <v-list nav dense v-for="item in routedItems" :key="item.id">
        <router-link :to="item.router" exact>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="red">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="color: red">{{
              item.text
            }}</v-list-item-title>
          </v-list-item>
        </router-link>
      </v-list>
      <!-- Elementos de menú con componentes -->
      <v-list nav dense v-for="item in componentItems" :key="item.id">
        <v-list-item
          link
          @click="loadComponent(item.component), emitEvent(item.text)"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: white">{{
            item.text
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div>
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import editAccount from "../relations/FormEdit.vue";
import Conceptos from "../relations/Concepts.vue";
import Empleados from "../relations/Employees.vue";

export default {
  props: {
    showNavigationDrawer: Boolean,
  },
  data() {
    return {
      customMobileBreakpoint: 300,
      routedItems: [],
      componentItems: [
        {
          text: "Cuenta corriente",
          icon: "mdi-account-details",
          id: 1,
          component: editAccount,
        },
        {
          text: "Conceptos",
          icon: "mdi-account-wrench",
          id: 2,
          component: Conceptos,
        },
        {
          text: "Empleados",
          icon: "mdi-account-lock",
          id: 3,
          component: Empleados,
        },
      ],
      currentComponent: editAccount,
    };
  },
  methods: {
    loadComponent(component) {
      this.currentComponent = component;
    },
    emitEvent(texto) {
      this.$emit("nameItem", texto);
    },
  },
};
</script>
